import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-main">
            <p>&copy; 2026 SLN BOOK WORLD - All your child's school books, in one click!</p>
          </div>
          <div className="footer-links">
            <Link to="/refund-cancellation">Refund & Cancellation Policy</Link>
            <span className="footer-separator">|</span>
            <Link to="/shipping-delivery">Shipping/Delivery Policy</Link>
            <span className="footer-separator">|</span>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <span className="footer-separator">|</span>
            <Link to="/terms-conditions">Terms & Conditions</Link>
            <span className="footer-separator">|</span>
            <Link to="/grievance-redressal">Grievance Redressal</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

